import Logo from 'components/logo';
import { FunctionComponent } from 'react';
import Container from 'components/container';
import { useFooterLinks } from 'hooks/useFooterLinks';
import { useNavigate } from 'hooks/useNavigate';
import { ROUTES } from 'constants/routes';

interface FooterProps {}

const Footer: FunctionComponent<FooterProps> = () => {
  const footerLinks = useFooterLinks();
  const navigate = useNavigate();

  return (
    <Container
      className='bg-black'
      innerClassName='lg:h-[152px] pb-8 pt-16 sm:pt-10 lg:py-0 flex flex-col-reverse lg:flex-row lg:items-center text-white'
    >
      <a
        className='block sm:mx-auto'
        href={ROUTES.home}
        onClick={(event) => {
          event.preventDefault();
          navigate(ROUTES.home);
        }}
      >
        <Logo />
      </a>
      <div className='overflow-hidden flex-grow flex sm:justify-center lg:justify-end mb-14 sm:mb-12 lg:mb-0'>
        <div className='flex flex-wrap -m-4'>
          {footerLinks.map((link) => (
            <div
              key={link.id}
              className='p-4 w-full sm:w-auto flex items-center hover:text-theme-main cursor-pointer'
            >
              <link.icon className='mr-2 w-6' />
              <a
                className='hover:text-theme-main'
                {...(link.onClickEvent
                  ? { onClick: link.onClickEvent, href: link.href }
                  : {
                      onClick: () => (window.location.href = link.href),
                      href: link.href,
                    })}
              >
                {link.title}
              </a>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default Footer;
